import { InputProps } from '@chakra-ui/react';
import { FieldHookConfig, useField } from 'formik';
import { useRef } from 'react';
import { Input } from 'ui-components/dist/Input';
import { capitalizeFirstLetter } from '~/core/utils';

interface Props extends InputProps {
  label: string;
  isDisabled?: boolean;
}

export const PlatformInput: React.FC<Props> = ({
  label,
  isDisabled,
  isInvalid,
  ...props
}) => {
  const inputRef = useRef<any>(null);
  const [field] = useField(props as FieldHookConfig<string>);

  return (
    <Input
      clearButtonProps={{ 'aria-label': label }}
      error={isInvalid ? 'Handle already exists in your agency.' : undefined}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      label={`${capitalizeFirstLetter(label)} handle`}
      name={field.name}
      ref={inputRef}
      size="lg"
      type="text"
      {...props}
    />
  );
};
